import { render, staticRenderFns } from "./YesNoInput.vue?vue&type=template&id=1060ad44&scoped=true"
import script from "./YesNoInput.vue?vue&type=script&lang=js"
export * from "./YesNoInput.vue?vue&type=script&lang=js"
import style0 from "./YesNoInput.vue?vue&type=style&index=0&id=1060ad44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1060ad44",
  null
  
)

export default component.exports